import { useSelector } from 'react-redux';

import { createSelector } from '@reduxjs/toolkit';

import type { RecurringSelectedOffer } from 'models';
import { getSchedule, getSelectedOffer } from 'selectors';

const getRecurringOffer = createSelector(
  [getSelectedOffer, getSchedule],
  (offer, schedule) => ({
    offer: offer as RecurringSelectedOffer,
    schedule,
  }),
);

function useRecurringOffer() {
  return useSelector(getRecurringOffer);
}

export { useRecurringOffer };
